import { cn } from '@/lib/cn'
import { site } from '@/config/site'
import { imageSrcSet, imageUrl } from '@/lib/images'
import { images } from '@/generated/images'

interface Props {
  className?: string
  tone?: 'dark' | 'light'
}

// Official GIA Longevity mark (laurel + globe + wordmark, monochrome blue).
// The light variant is derived from the same asset via CSS filter so the
// two stay in lockstep if the brand file is swapped.
export function Logo({ className, tone = 'dark' }: Props) {
  return (
    <a
      href="/#hero"
      aria-label={`${site.name}, U.S. Chapter, home`}
      className={cn('inline-flex items-center no-underline', className)}
    >
      <picture className="contents">
        <source
          type="image/avif"
          srcSet={imageSrcSet('logo-horizontal', 'avif')}
          sizes="(min-width: 1024px) 186px, (min-width: 640px) 160px, 133px"
        />
        <img
          src={imageUrl('logo-horizontal', 'webp', 400)}
          srcSet={imageSrcSet('logo-horizontal', 'webp')}
          sizes="(min-width: 1024px) 186px, (min-width: 640px) 160px, 133px"
          width={images['logo-horizontal'].width}
          height={images['logo-horizontal'].height}
          alt={`${site.fullName} logo`}
          // Above the fold in the header; the footer copy is far down.
          loading={tone === 'dark' ? 'eager' : 'lazy'}
          decoding="async"
          className={cn(
            'h-auto max-h-10 w-auto max-w-[40vw] sm:max-h-12 sm:max-w-none lg:max-h-14',
            tone === 'light' && 'brightness-0 invert',
          )}
        />
      </picture>
    </a>
  )
}
